import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAddExpEducationData,
  fetchAdvancedEducationOptions,
  fetchDeleteEducation,
  fetchDentalMedicalOptions,
  fetchExpEducationList,
  fetchOtherGraduteOptions,
  fetchProviderEduType,
  fetchSearchQuery,
  fetchUnderGraduateOptions,
  fetchUpdateEducationList,
} from "./ProviderEducationActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerEduTypeDropdown = createSlice({
  name: "providerEduTypeDropdown",
  initialState: {
    isEduTypeLoading: false,
    eduTypeData: [],
    eduTypeError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderEduType.pending, (state) => {
        state.isEduTypeLoading = true;
        state.eduTypeError = null;
      })
      .addCase(fetchProviderEduType.fulfilled, (state, action) => {
        state.isEduTypeLoading = false;
        state.eduTypeData = action.payload;
      })
      .addCase(fetchProviderEduType.rejected, (state, action) => {
        state.isEduTypeLoading = false;
        state.eduTypeError = action.error.message;
      });
  },
});

const providerOtherEducationOptions = createSlice({
  name: "providerOtherEducationOptions",
  initialState: {
    isOtherEduLoading: false,
    otherEduOptions: [],
    otherEduError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOtherGraduteOptions.pending, (state) => {
        state.isOtherEduLoading = true;
        state.otherEduError = null;
      })
      .addCase(fetchOtherGraduteOptions.fulfilled, (state, action) => {
        state.isOtherEduLoading = false;
        state.otherEduOptions = action.payload;
      })
      .addCase(fetchOtherGraduteOptions.rejected, (state, action) => {
        state.isOtherEduLoading = false;
        state.otherEduError = action.error.message;
      });
  },
});

const providerAdvancedEducationOptions = createSlice({
  name: "providerAdvancedEducationOptions",
  initialState: {
    isadvancedLoading: false,
    advancedData: [],
    advancedError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvancedEducationOptions.pending, (state) => {
        state.isadvancedLoading = true;
        state.advancedError = null;
      })
      .addCase(fetchAdvancedEducationOptions.fulfilled, (state, action) => {
        state.isadvancedLoading = false;
        state.advancedData = action.payload;
      })
      .addCase(fetchAdvancedEducationOptions.rejected, (state, action) => {
        state.isadvancedLoading = false;
        state.advancedError = action.error.message;
      });
  },
});

const providerUndergraduateOption = createSlice({
  name: "providerUndergraduateOption",
  initialState: {
    isUnderGraduateLoading: false,
    underGraduateData: [],
    underGrdError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnderGraduateOptions.pending, (state) => {
        state.isUnderGraduateLoading = true;
        state.underGrdError = null;
      })
      .addCase(fetchUnderGraduateOptions.fulfilled, (state, action) => {
        state.isUnderGraduateLoading = false;
        state.underGraduateData = action.payload;
      })
      .addCase(fetchUnderGraduateOptions.rejected, (state, action) => {
        state.isUnderGraduateLoading = false;
        state.underGrdError = action.error.message;
      });
  },
});

const providerDentalMedical = createSlice({
  name: "providerDentalMedical",
  initialState: {
    isDentaMedialLoading: false,
    dentalMedicalData: [],
    dentalMedicalError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDentalMedicalOptions.pending, (state) => {
        state.isDentaMedialLoading = true;
        state.dentalMedicalError = null;
      })
      .addCase(fetchDentalMedicalOptions.fulfilled, (state, action) => {
        state.isDentaMedialLoading = false;
        state.dentalMedicalData = action.payload;
      })
      .addCase(fetchDentalMedicalOptions.rejected, (state, action) => {
        state.isDentaMedialLoading = false;
        state.dentalMedicalError = action.error.message;
      });
  },
});

const providerEduInstitutionSearch = createSlice({
  name: "providerEduInstitutionSearch",
  initialState: {
    isEduInstituteDataLoading: false,
    isInstituteSearchData: [],
    insituteSearchError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchQuery.pending, (state) => {
        state.isEduInstituteDataLoading = true;
        state.insituteSearchError = null;
      })
      .addCase(fetchSearchQuery.fulfilled, (state, action) => {
        state.isEduInstituteDataLoading = false;
        if (!action.payload.success) {
          state.insituteSearchError = true;
        } else {
          state.isInstituteSearchData =
            action.payload?.data?.data?.institutionResponseDTO?.items;
        }
      })
      .addCase(fetchSearchQuery.rejected, (state, action) => {
        state.isEduInstituteDataLoading = false;
        state.insituteSearchError = action.error.message;
      });
  },
});

const providerExperienceEducation = createSlice({
  name: "providerExperienceEducation",
  initialState: {
    isEduLoading: false,
    expEduData: [],
    eduError: null,
    eduErrorMsg: "",
    eduDeleteError: "",
    eduDeleteLoading: false,
  },
  reducers: {
    addProviderExpEdu: (state, action) => {
      state.expEduData = action.payload;
    },
    deleteProviderExpEdu: (state, action) => {
      state.expEduData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpEducationList.pending, (state) => {
        state.isEduLoading = true;
        state.eduError = null;
      })
      .addCase(fetchExpEducationList.fulfilled, (state, action) => {
        if (!action.payload.success) {
          if (
            action.payload.data.metadata?.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.eduError = false;
            state.expEduData = [];
            state.isEduLoading = false;
          } else {
            state.isEduLoading = false;
            state.eduError = true;
            state.eduErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.isEduLoading = false;
          state.eduError = false;
          state.expEduData =
            action.payload.data.data.providerEducationResponseDTO;
        }
      })
      .addCase(fetchExpEducationList.rejected, (state, action) => {
        state.isEduLoading = false;
        state.eduError = action.error.message;
      });
    builder
      .addCase(fetchAddExpEducationData.pending, (state) => {
        state.isEduLoading = true;
        state.eduError = null;
      })
      .addCase(fetchAddExpEducationData.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isEduLoading = false;
          state.eduError = true;
          state.eduErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isEduLoading = false;
          state.eduError = false;
        }
      })
      .addCase(fetchAddExpEducationData.rejected, (state, action) => {
        state.isEduLoading = false;
        state.eduError = action.error.message;
      });
    builder
      .addCase(fetchDeleteEducation.pending, (state) => {
        state.eduDeleteLoading = true;
      })
      .addCase(fetchDeleteEducation.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isEduLoading = false;
          state.eduError = true;
          state.eduErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isEduLoading = false;
          state.eduError = false;
        }
      })
      .addCase(fetchDeleteEducation.rejected, (state) => {
        state.eduDeleteLoading = true;
        state.eduDeleteError = "Something Went Wrong!. Please try again later.";
      });
    builder
      .addCase(fetchUpdateEducationList.pending, (state) => {
        state.eduDeleteLoading = true;
      })
      .addCase(fetchUpdateEducationList.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isEduLoading = false;
          state.eduError = true;
          state.eduErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isEduLoading = false;
          state.eduError = false;
        }
      })
      .addCase(fetchUpdateEducationList.rejected, (state) => {
        state.eduDeleteLoading = true;
        state.eduDeleteError = "Something Went Wrong!. Please try again later.";
      });
  },
});

export const providerEduTypeReducer = providerEduTypeDropdown.reducer;
export const providerOtherEduOptionReducer =
  providerOtherEducationOptions.reducer;
export const providerAdvancedEduOptionReducer =
  providerAdvancedEducationOptions.reducer;
export const providerOtherGraduateEduOptionReducer =
  providerUndergraduateOption.reducer;
export const providerDentalMedicalEduOptionReducer =
  providerDentalMedical.reducer;
export const providerEduInstitutionSearchReducer =
  providerEduInstitutionSearch.reducer;
export const { addProviderExpEdu, deleteProviderExpEdu } =
  providerExperienceEducation.actions;
export const providerExpEducationReducer = providerExperienceEducation.reducer;
